import React, { useEffect, useState } from "react";
import "./FAQAccordian.css";

const SearchInput = ({ faqData, setfaqData }) => {
    const handleSearch = (e) => {
        const searchTerm = e.target.value.trim().toLowerCase();
        if (!searchTerm) {
            setfaqData([...faqData]);
            return;
        }

        const filteredItems = faqData.map((item) => {

            let GeneralFAQs = item.GeneralFAQs.filter((faq) => faq.question.toLowerCase().includes(searchTerm))
            let Nominations = item.Nominations.filter((faq) => faq.question.toLowerCase().includes(searchTerm))
            let Curriculum = item.Nominations.filter((faq) => faq.question.toLowerCase().includes(searchTerm))
            let smeSession = item.smeSession.filter((faq) => faq.question.toLowerCase().includes(searchTerm))
            let Certification = item.Certification.filter((faq) => faq.question.toLowerCase().includes(searchTerm))
            return { ...item, GeneralFAQs: GeneralFAQs, Nominations: Nominations, Curriculum: Curriculum, smeSession: smeSession, Certification: Certification }

        });

        setfaqData(filteredItems);
    };


    return (
        <div className="search-box-contsiner">
            <input
                type="text"
                placeholder="Search..."
                //value={searchTerm}
                onChange={handleSearch}
                className="search-box"
            />
            <img className="search-icon" src="images/FAQ/Search-icon.png" />
        </div>
    );
};

export default SearchInput;
